import { api_GET, api_POST, api_PUT } from './_api';

const naoColeta_api = {
    GetList: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`NaoColeta/GetList`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default naoColeta_api;